import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "detection-volume",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Detection volume and trend over the selected time range.",
    domain: "detections",
    visual: "Line chart",
    purposes: ["live"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "chart" },
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
